import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';

interface MultibleLinesConfig {
    lineConfig?: Array<{ translationKey: string, type: string }>;
    multibleLines?: boolean;
}

@Injectable({
    providedIn: 'root'
})

export class ErrorMsgService {

    private _errorMessage = new BehaviorSubject<string>(null);
    errorMessage = this._errorMessage.asObservable();

    setMessage(message) {
        this._errorMessage.next(message);
    }

    getMessage() {
        return this._errorMessage;
    }

    private _reloadOnClose = new BehaviorSubject<boolean>(false);
    reloadOnClose = this._reloadOnClose.asObservable();

    setReloadOnClose(bool) {
        this._reloadOnClose.next(bool);
    }

    getReloadOnCloase() {
        return this._reloadOnClose;
    }


    private _textArray = new BehaviorSubject<object>({});
    textArray = this._textArray.asObservable();

    setTextArray(obj) {
        this._textArray.next(obj);
    }

    getTextArray() {
        return this._textArray;
    }

    private _multibleLinesConfig = new Subject<MultibleLinesConfig>();
    multibleLinesConfig = this._multibleLinesConfig.asObservable();

    setMultibleLinesConfig(obj) {
        this._multibleLinesConfig.next(obj);
    }

    getMultibleLinesConfig() {
        return this.multibleLinesConfig;
    }

    resetMultibleLinesConfig() {
        // No need to emit anything when resetting since Subject doesn't have initial value
    }

}